
import { useState } from 'react';
import Logo from "../../assets/images/login-logo.svg";
// import Loginbg from "../../assets/images/login-bg.webp";
import Loginbg from "../../assets/images/login-admin.png";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";
import "./login.scss";
import WebService from '../../Services/WebService';
import { toast } from 'react-toastify';

const CreatePassword = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const email = location.state?.email || "";
    const referenceNumber = location.state?.referenceNumber || "";

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [type1, setType1] = useState("password");
    const [type2, setType2] = useState("password");

    const [errors, setErrors] = useState<any>({});
    const [loading, setLoading] = useState(false);

    const [type, setType] = useState('password');
    const [icon, setIcon] = useState<any>(BsEyeSlash);

    const passwordRegex =
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

    const validateForm = () => {
        let err: any = {};

        if (!password) err.password = "Please enter password";
        else if (!passwordRegex.test(password))
            err.password =
                "Password must contain at least 8 characters, including uppercase, lowercase, number & special character.";

        if (!confirmPassword) err.confirmPassword = "Please re-enter password";
        else if (password !== confirmPassword)
            err.confirmPassword = "Passwords do not match";

        setErrors(err);
        return Object.keys(err).length === 0;
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);

        try {
            const res: any = await WebService.postAPI({
                action: "admin-auth/forgot-password/reset-password",
                body: {
                    new_password: password,
                    remember_token: referenceNumber,
                },
                isShowError: false,
            });

            if (res?.status) {
                toast.success(res?.message || "Password updated successfully!");
                navigate("/login");
            }
        } catch (error: any) {
            toast.error(error?.response?.data?.message || "Failed to reset password");
        } finally {
            setLoading(false);
        }
    };

    const handleLogin = () => {
        navigate("/dashboard"); // redirect
    };

    const handleToggle = () => {
        if (type === 'password') {
            setIcon(BsEye);
            setType('text')
        } else {
            setIcon(BsEyeSlash)
            setType('password')
        }
    }
    return (
        <div className="min-h-screen flex login-page">
            {/* Left side - Image */}
            <div className="w-3/4 hidden md:block">
                <img
                    src={Loginbg}
                    alt="Login side"
                    className="w-full h-full object-cover"
                />
            </div>

            {/* Right side - Form */}
            <div className="w-full md:w-1/2 flex flex-col justify-center items-center p-8 bg-white">
                {/* Logo */}
                <div className="mb-6 flex flex-col items-center">
                    <div className='pb-8'>
                        <img src={Logo} alt="Logo" className="" width={277} height={240} />
                    </div>
                    <h1>Create password</h1>
                </div>

                {/* Form */}
                <form className="w-full max-w-sm" onSubmit={handleSubmit}>
                    <div className="mb-4 relative">
                        <label className="block mb-2">
                            Password
                        </label>
                        <input
                            type={type1}
                            placeholder="Enter password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className={`w-full px-4 py-2 pr-10 border rounded-lg focus:ring-2 ${errors.password
                                ? "border-red-500 ring-red-300"
                                : "border-gray-300 ring-blue-400"
                                }`}
                        />
                        <span
                            className="absolute right-3 top-10 cursor-pointer"
                            onClick={() =>
                                setType1(type1 === "password" ? "text" : "password")
                            }
                        >
                            {type1 === "password" ? (
                                <BsEye size={18} />
                            ) : (
                                <BsEyeSlash size={18} />
                            )}
                        </span>
                        {errors.password && (
                            <p className="text-red-500 text-sm error-text">{errors.password}</p>
                        )}
                    </div>

                    {/* Confirm Password */}
                    <div className="mb-4 relative">
                        <label className="block mb-2">Re-enter Password</label>
                        <input
                            type={type2}
                            placeholder="Re-enter password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            className={`w-full px-4 py-2 pr-10 border rounded-lg focus:ring-2 ${errors.confirmPassword
                                ? "border-red-500 ring-red-300"
                                : "border-gray-300 ring-blue-400"
                                }`}
                        />
                        <span
                            className="absolute right-3 top-10 cursor-pointer"
                            onClick={() =>
                                setType2(type2 === "password" ? "text" : "password")
                            }
                        >
                            {type2 === "password" ? (
                                <BsEye size={18} />
                            ) : (
                                <BsEyeSlash size={18} />
                            )}
                        </span>
                        {errors.confirmPassword && (
                            <p className="text-red-500 text-sm error-text">
                                {errors.confirmPassword}
                            </p>
                        )}
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        className="mt-2 w-full bg-blue-400 hover:bg-blue-500 text-white font-medium py-2 rounded-lg"
                    >
                        {loading ? "Submitting..." : "Submit"}
                    </button>

                    <button
                        type="button"
                        onClick={() => navigate("/login")}
                        className="mt-3 w-full text-sm text-blue-500 hover:text-blue-600 underline cursor-pointer bg-transparent font-medium py-2 rounded-lg"
                    >
                        Back to Login
                    </button>
                </form>
            </div>
        </div>
    )

}
export default CreatePassword;